// Gets the number of filters to display in Filter Ghost Button (Filter: nunmFilters)
export const getNumFilters = (appliedFilters) => {
    if (appliedFilters.length < 1) {
        return 0;
    }
    else {
        let numFilters = 0;

        appliedFilters.forEach(filter => {
            if (filter.filterSelection.length > 0) {
                numFilters += 1;
            }
        });

        return numFilters;
    }
}

export const insertAt = (arr, index, ...newItems) => [
    // part of the array before the specified index
    ...arr.slice(0, index),
    // inserted items
    ...newItems,
    // part of the array after the specified index
    ...arr.slice(index)
  ]

export const getNamesArray = (names) => {
    let result = [];
    if (names) {
        if (!(names === "-" || names === "")) {
            result = names.split(",");
        }
    }
    return result;
};
